import { PermissionCheckerService } from 'abp-ng2-module';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, RoutesRecognized, NavigationEnd } from '@angular/router';
import { AppSessionService } from '@axilla/axilla-shared';
import { environment } from './environments/environment';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';
import {OrderStateService} from '@app/webshop/field-agent/shared/services/order-state.service';

@Injectable({
    providedIn: 'root'
})
export class RootRouteGuard  {
    static tenantUrl = '/app/admin/tenants';
    static loginUrl = '/account/login';
    static webshopUrl = '/app/webshop/dashboard';
    static marriottUrl = '/marriott';

    static selectCustomer = '/app/webshop/field-agent/select-customer';
    static fieldAgentDashboard = '/app/webshop/field-agent/select-templates';

    constructor(
        private _permissionChecker: PermissionCheckerService,
        private _router: Router,
        private _sessionService: AppSessionService,

        private _orderStateService: OrderStateService,
    ) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (route.queryParams['ss'] && route.queryParams['ss'] === 'true') {
            return true;
        }

        const portalUrl = environment.baseUrlHost;
        if (location.hostname.includes(portalUrl)) {
            if (location.pathname.includes(RootRouteGuard.marriottUrl)) {
                return true;
            }

            //prevent autorized user reach /marriott page
            //if (!this._sessionService.user && location.pathname.includes(RootRouteGuard.marriottUrl)) {
            //    return true;
            //} else {
            //    this.navigate(this.portalUrlDetector(state));
            //    return false;
            //}

            this.navigate(this.portalUrlDetector(state));
            return true;
        }

        if (this._sessionService.user) {
            this.navigate(this.selectBestRoute());
            return false;
        } else {
            this.navigate(RootRouteGuard.webshopUrl);
            return true;
        }

        return true;
    }

    selectBestRoute(): string {
        //Check if user is HOSTADMIN
        //redirect to the /app/admin/tenants
        let hostAdmin = this._permissionChecker.isGranted('Pages.Administration.Host.Settings');
        if (hostAdmin) {
            return RootRouteGuard.tenantUrl;
        }

        const guidedUser = this._permissionChecker.isGranted(BasePermissionDefinition.Webshop.View.Guided);
        if (guidedUser && !!abp.session.impersonatorUserId) {
            this._orderStateService.selectTemplates();
            return RootRouteGuard.fieldAgentDashboard;
        }

        const fieldAgent = this._permissionChecker.isGranted(BasePermissionDefinition.Webshop.Customer.CustomerOverview);
        if (fieldAgent) {
            return RootRouteGuard.selectCustomer;
        }

        //should be default for PunchOut users
        return RootRouteGuard.webshopUrl;
    }

    navigate(url: string) {
        this._router.navigate([url]);
    }

    portalUrlDetector(state: RouterStateSnapshot): string {
        const url = state.url;

        if (this._sessionService.user) {
            const guidedUser = this._permissionChecker.isGranted(BasePermissionDefinition.Webshop.View.Guided);
            if (guidedUser && !!abp.session.impersonatorUserId) {
                this._orderStateService.selectTemplates();
                return RootRouteGuard.fieldAgentDashboard;
            }

            const fieldAgent = this._permissionChecker.isGranted(BasePermissionDefinition.Webshop.Customer.CustomerOverview);
            if (fieldAgent) {
                return RootRouteGuard.selectCustomer;
            }

            return RootRouteGuard.webshopUrl;
        } else {
            return RootRouteGuard.loginUrl;
        }

        return RootRouteGuard.webshopUrl;
    }
}
